import { IS_CHINA } from 'constants/environments'
import { ABOUT, HELP } from 'constants/pageNames'
import { versions } from 'constants/versions'

/* 外部連結 */
const ROOT_PATH = (baseUrl = '') =>
  IS_CHINA ? 'https://pagamo.cn' : `https://www.pagamo.org${baseUrl}`

const STATIC_WEBSITES_ROOT_PATH = pageName =>
  IS_CHINA ? `https://${pageName}.pagamo.cn` : `https://${pageName}.pagamo.org`

export const PATH = (baseUrl = '') => ({
  HOME_PAGE: ROOT_PATH(baseUrl),
  COURSES: `${ROOT_PATH(baseUrl)}/#courses`,
  LATEST_NEWS: `${ROOT_PATH(baseUrl)}/#newsletters`,
  DOWNLOAD_APP: `${ROOT_PATH(baseUrl)}/#game-app`,
  SIGN_UP: `${ROOT_PATH(baseUrl)}/sign_up`,
  TERMS_OF_USE: `${ROOT_PATH()}/application/terms_of_use`,
  PRIVACY_POLICY: `${ROOT_PATH()}/application/privacy_policy`,
  JOIN_US:
    'https://www.104.com.tw/jobbank/custjob/index.php?r=cust&j=483a426b34363e6730323a63383e36197292929244036366785j56',

  ABOUT_PRODUCT: `${STATIC_WEBSITES_ROOT_PATH(ABOUT)}${baseUrl}/product`,
  ABOUT_TEAM: `${STATIC_WEBSITES_ROOT_PATH(ABOUT)}${baseUrl}/team`,
  HELP_CENTER: `${STATIC_WEBSITES_ROOT_PATH(HELP)}${baseUrl}`,

  ABOUT_PAGE: `${STATIC_WEBSITES_ROOT_PATH(ABOUT)}`,
  APP_PAGE_IMAGE_URL:
    'https://d32j6uwsrra4gx.cloudfront.net/assets/courses_hall/PaGamO_Logo-2e7bd58870249960b0f26e2c71dc3623516fc9db7b0bc5c1bcc14b9bc489be5c.png',
})

export const SOCIAL_MEDIA_URL = {
  WEIBO: 'https://weibo.com/PaGamO',
  YOUKU: 'https://i.youku.com/i/UMzI2NzAzNDczNg',
  YOUTUBE: 'https://www.youtube.com/channel/UCiFBR083e9jVCKH5YcEgcGw',
  FACEBOOK: 'https://www.facebook.com/pagamo2014/',
  FACEBOOK_MY: 'https://www.facebook.com/PaGamOMalaysia/',
  YOUTUBE_LEARNING:
    'https://www.youtube.com/watch?v=1lyAQXEki48&list=PLQm7Z_5e808G7R7NkgnZfafHw85zPVXJw',
}

export const DOWNLOAD_APP_URL = {
  IOS: {
    [versions.TW]: 'https://itunes.apple.com/app/pagamo/id1114434167',
    [versions.EN]: 'https://itunes.apple.com/app/pagamo/id1114434167',
    [versions.CN]: 'https://itunes.apple.com/cn/app/pagamo-china/id1079252424',
  },
  ANDROID: {
    [versions.TW]:
      'https://play.google.com/store/apps/details?id=com.boniotw.global.pagamo',
    [versions.EN]:
      'https://play.google.com/store/apps/details?id=com.boniotw.global.pagamo',
    [versions.CN]: 'https://global-cdn.pagamo.cn/files/PaGamO_CN.apk',
  },
}

export const PREVIEW_IMAGE_URL =
  'https://d32j6uwsrra4gx.cloudfront.net/assets/courses_hall/PaGamO_Logo-2e7bd58870249960b0f26e2c71dc3623516fc9db7b0bc5c1bcc14b9bc489be5c.png'
